export function initializeProductOptions(root = document) {
  if (!root.body?.classList.contains('mhecomm-he-pdp-page')) {
    return;
  }

  const studentTabs = root.querySelector('.student-nav-tabs');
  const instructorTabs = root.querySelector('.instructor-nav-tabs');
  const tabContent = root.querySelector('.purchase-options-tabs .tab-content');
  if (!studentTabs || !instructorTabs || !tabContent) {
    return;
  }

  const showTabInBar = (nav) => {
    const tab = nav.querySelector('.nav-link.active') || nav.querySelector('.nav-link');
    if (tab) {
      tab.classList.remove('active');
      window.bootstrap.Tab.getOrCreateInstance(tab).show();
    }
  };

  const verifyUpcomingReleaseMessage = () => {
    const select = root.querySelector('.editionReleaseSelect');
    const upcoming = select?.querySelector('.upcomingReleaseAlert');
    const selected = select?.querySelector('input')?.value;
    root.querySelectorAll('.instructor-tab .upcomingReleaseMessage').forEach((message) => {
      message.classList.toggle(
        'd-none',
        !upcoming || selected === upcoming.dataset.value || upcoming.classList.contains('d-none')
      );
    });
  };

  const changeView = (view) => {
    tabContent.querySelectorAll('.tab-pane.active').forEach((pane) => pane.classList.remove('active', 'show'));
    const showInstructor = view === 'instructor';
    studentTabs.classList.toggle('d-none', showInstructor);
    instructorTabs.classList.toggle('d-none', !showInstructor);
    showTabInBar(showInstructor ? instructorTabs : studentTabs);
    verifyUpcomingReleaseMessage();
  };

  root
    .querySelectorAll('.tab-content .tab-pane.active[id*="nav-purchase"]')
    .forEach((pane) => pane.classList.remove('active'));
  root.querySelectorAll('#navTabs .nav-link.active').forEach((tab) => {
    tab.classList.remove('active');
    window.bootstrap.Tab.getOrCreateInstance(tab).show();
  });

  const activeView = root.querySelector('.studentInstructorToggleGroup .nav-link.active')?.dataset.layerPdpViewType;
  changeView(activeView || new URLSearchParams(window.location.search).get('viewOption') || 'student');
  document.addEventListener('studentInstructorToggleGroupChange', (event) => changeView(event.detail?.value));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeProductOptions(), { once: true });
} else {
  initializeProductOptions();
}
